import { Icon } from "@iconify/react";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { GrClose } from "react-icons/gr";
import FusionLogo from "../../../../assets/logo/FusionLogo.png";
// import component 👇
import Drawer from "react-modern-drawer";

//import styles 👇
import "react-modern-drawer/dist/index.css";
import { useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  ACGHealthInsightsMenu,
  adminType,
  ClinicalConsultingSubMenu,
  HEADER_MENU,
  HEADER_MENU_CLIENT,
  ResourcesSubMenu,
} from "../../../../Utils/constants";
import Fontstyling from "../../comman";

const RightDrawer = ({ isOpen, setIsOpen, navigate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const [dropdown, setDropdown] = useState(false);
  const [adminDropdown, setAdminDropdown] = useState(false);
  const [isClinicalDropdown, setClinicalDropdown] = useState(false);
  const [isResourcesDropdown, setResourcesDropdown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDropdown(false);
  }, [isOpen]);
  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };
  const linkStyle = {
    textDecoration: "none",
    color: "black",
    fontWeight: "700",
    padding: "10px",
  };
  const activeStyle = { ...linkStyle, borderBottom: "8px solid #00AEEF" };
  return (
    <>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="right"
        className="bla"
        duration="500"
      >
        <div onClick={toggleDrawer} className="text-end me-4 pt-2 fs-4">
          <GrClose />
        </div>
        <hr />
        <div style={{overflowY: 'auto',height: "450px" }}>
          {user?.UserRole === "Client" ?
            <div className="d-flex flex-column gap-3">
              {HEADER_MENU_CLIENT.map(({ id, title, pathName }) => {
                if (id == 1 && user?.gpoId > 0) {
                  return (
                    <NavLink
                      to={pathName}
                      style={({ isActive }) =>
                        isActive ? activeStyle : linkStyle
                      }
                      key={id}
                    >
                      {title}
                    </NavLink>
                  );
                } else if (id === 2) {
                  return (
                      <NavLink
                        to={pathName}
                        style={({ isActive }) =>
                          isActive ? activeStyle : linkStyle
                        }
                        key={id}
                      >
                        <img src={FusionLogo} alt="IA Dashboard" width={25} />
                      </NavLink>
                  );
               }
              })}
            </div> :
            <div className="d-flex flex-column gap-3">
              {HEADER_MENU.map((item, id) => {
                if (item.id === 2) {
                  return (
                    <NavDropdown
                      show={dropdown}
                      title="Health Insights"
                      style={{
                        textDecoration: "none",
                        padding: "10px",
                        color: "black",
                        fontWeight: "700",
                        borderBottom: location.pathname.match("ACGHealthInsights")
                          ? "8px solid #00AEEF"
                          : "",
                      }}
                      className="rounded-0"
                      onClick={(e) => {
                        setDropdown((prev) => !prev);
                      }}
                      id="nav-dropdown"
                    >
                      {" "}
                      {ACGHealthInsightsMenu.map((el, index) =>
                        user?.UserRole === "Admin" ? (
                          <NavDropdown.Item
                            as={Link}
                            className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                            to={el.path}
                            style={
                              location.pathname.includes(`${el.pathName}`)
                                ? {
                                  backgroundColor: "#00aeef",
                                  color: "white",
                                  textDecoration: "none",
                                }
                                : {}
                            }
                            onClick={(e) => {
                              setIsOpen(false);
                              setDropdown(false);
                            }}
                          >
                            <span>
                              <Icon icon={el.icon} width={24} height={28} />
                            </span>
                            <div
                              style={{
                                ...Fontstyling.secondHeading,
                                color:
                                  location.pathname.includes(`${el.pathName}`) &&
                                  "white",
                                letterSpacing: "0.1px",
                              }}
                            >
                              {el.title}
                            </div>
                          </NavDropdown.Item>
                        ) : (
                          el.id !== 1 && (
                            <NavDropdown.Item
                              as={Link}
                              className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                              to={el.path}
                              style={
                                location.pathname.includes(`${el.pathName}`)
                                  ? {
                                    backgroundColor: "#00aeef",
                                    color: "white",
                                    textDecoration: "none",
                                  }
                                  : {}
                              }
                              onClick={() => setDropdown(false)}
                            >
                              <span>
                                <Icon icon={el.icon} width={24} height={28} />
                              </span>
                              <div
                                style={{
                                  ...Fontstyling.sidebarheading,
                                  color:
                                    location.pathname.includes(`${el.pathName}`) &&
                                    "white",
                                  letterSpacing: "0.1px",
                                }}
                              >
                                {el.title}
                              </div>
                            </NavDropdown.Item>
                          )
                        )
                      )}
                    </NavDropdown>
                  );
                }else if (id === 4) {
                  return (
                    <>
                      <NavDropdown
                        show={isResourcesDropdown}
                        title="Resources"
                        style={{
                          textDecoration: "none",
                          padding: "10px",
                          color: "black",
                          fontWeight: "700",
                          borderBottom: location.pathname.match("resourcecenter") ? "8px solid #00AEEF" : "",
                        }}
                        className="rounded-0 w-auto"
                        onMouseEnter={(e) =>setResourcesDropdown(true)}
                        onMouseLeave={(e) =>setResourcesDropdown(false)}
                        id="nav-dropdown"
                      >
                        {ResourcesSubMenu.map((el, index) => {
                            return (
                              <NavDropdown.Item
                                as={Link}
                                target={el.title === "Resource Center" ? '_self' : '_blank'}
                                className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                                to={el.pathName}
                                style={
                                  location.pathname.includes(`${el.pathName}`)
                                    ? {
                                        backgroundColor: "#00aeef",
                                        color: "white",
                                        textDecoration: "none",
                                      }
                                    : {}
                                }
                                onClick={() => setResourcesDropdown(false)}
                              >
                              <div
                                style={{
                                  ...Fontstyling.secondHeading,
                                  color:
                                    location.pathname.includes(
                                      `${el.pathName}`
                                    ) && "white",
                                  letterSpacing: "0.1px",
                                }}
                              onClick={(e)=>setIsOpen(false)}
                              >
                                {el.title}
                              </div>
                            </NavDropdown.Item>
                            )
                        })}
                      </NavDropdown>
                    </>
                  );
                } else if (item.id === 5) {
                  return (
                    <NavLink
                      to={item.pathName}
                      style={({ isActive }) => (isActive ? activeStyle : linkStyle)}
                      key={id}
                    >
                      <img src={FusionLogo} alt="IA Dashboard" width={25} />
                    </NavLink>
                  );
                } else if (item.id === 7) {
                  return (
                    <div onClick={(e) => { }} key={item.id}>
                      <a
                        className="nav-link"
                        href="https://login.cgt.us/cas/login?service=https%3A%2F%2Finfusedanalytics.hba.cgt.us%2Flogin%2Fcas"
                        target="_blank"
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontWeight: 700,
                          padding: "10px",
                        }}
                      >
                        {item.title}
                      </a>
                    </div>
                  );
                } else if (
                  item.id === 9 &&
                  (user?.IsClinicalIntakerights === 1 ||
                    user?.UserRole === "Admin" ||
                    user?.UserRole === "Clinician")
                ) {
                  return (
                    <>
                      <NavDropdown
                        show={isClinicalDropdown}
                        title="Clinical Consulting"
                        style={{
                          textDecoration: "none",
                          padding: "10px",
                          color: "black",
                          fontWeight: "700",
                          borderBottom: location.pathname.match(
                            "clinicalconsulting"
                          )
                            ? "8px solid #00AEEF"
                            : "",
                        }}
                        className="rounded-0"
                        onMouseEnter={(e) => {
                          setClinicalDropdown(true);
                        }}
                        onMouseLeave={() => {
                          setClinicalDropdown(false);
                        }}
                        id="nav-dropdown"
                      >
                        {ClinicalConsultingSubMenu.map((el, index) => (
                          <a
                            href={el.hyperlink}
                            target="_blank"
                            className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                            style={{
                              color: "black",
                              fontWeight: 700,
                              padding: "10px",

                            }}
                          >
                            <span>
                              <img
                                src={el.icon}
                                width={20}
                                className="rounded-5"
                              />
                            </span>
                            <div
                              style={{
                                ...Fontstyling.sidebarheading,
                                color:
                                  location.pathname.includes(
                                    `${el.pathName}`
                                  ) && "white",
                                letterSpacing: "0.1px",
                                fontSize: "12px",
                              }}
                            >
                              {el.title}
                            </div>
                          </a>

                        ))}
                      </NavDropdown>
                    </>
                  );
                } else if (
                  (item.id !== 3 && item.id !== 6 && item.id !== 9) ||
                  (item.id === 3 &&
                    (user?.IsEmpoweRx === 1 || user?.UserRole === "Admin" || user?.UserRole === "Pharmacy")) ||
                  (item.id === 6 &&
                    (user?.IsClinicalIntakerights === 1 ||
                      user?.UserRole === "Admin" ||
                      user?.UserRole === "Clinician"))
                ) {
                  return (
                    <NavLink
                      to={item.pathName}
                      style={({ isActive }) => (isActive ? activeStyle : linkStyle)}
                      key={id}
                      onClick={() => setIsOpen(false)}
                    >
                      {item.title}
                    </NavLink>
                  );
                }
              })}
            </div>
}

        {user?.UserRole && user?.UserRole === "Admin" ? (
          // <NavDropdown
          //   show={adminDropdown}
          //   title="Admin"
          //   style={{
          //     textDecoration: "none",
          //     padding: "10px",
          //     color: "white",
          //     fontWeight: "700",
          //   }}
          //   className="primary-button px-4 mt-3"
          //   // onClick={() => navigate("/admin")}
          //   onMouseEnter={(e) => {
          //     setAdminDropdown(true);
          //   }}
          //   onMouseLeave={() => {
          //     setAdminDropdown(false);
          //   }}
          //   id="nav-dropdown"
          // >
          //   {" "}
          //   {adminType.map((el, index) => (
          //     <NavDropdown.Item
          //       as={Link}
          //       className="d-flex align-items-center gap-3 py-2 text-decoration-none"
          //       to={el.path}
          //       style={
          //         location.pathname.includes(`${el.path}`)
          //           ? {
          //               backgroundColor: "#00aeef",
          //               color: "white",
          //               textDecoration: "none",
          //             }
          //           : {}
          //       }
          //       onClick={() => setAdminDropdown(false)}
          //     >
          //       <span>
          //         <Icon icon={el.icon} width={24} height={28} />
          //       </span>
          //       <div
          //         style={{
          //           ...Fontstyling.secondHeading,
          //           color: location.pathname.includes(`${el.path}`) && "white",
          //           letterSpacing: "0.1px",
          //         }}
          //       >
          //         {el.title}
          //       </div>
          //     </NavDropdown.Item>
          //   ))}
          // </NavDropdown>
          <div className="d-flex align-items-center mt-3">
          <NavLink
                  to={"/admin"}
                  style={{
                        textDecoration: "none",
                        padding: "10px",
                        color: "white",
                        fontWeight: "700",
                      }}
                  className="primary-button px-4"
                >
                  {"Admin"}
                </NavLink>
            </div>
        )  : user?.UserRole !== "Client" && (
          <div className="d-flex align-items-center mt-3">
             <NavLink
              to={"/servicerequest"}
              className="w-100"
              style={({ isActive }) => (isActive ? activeStyle : linkStyle)}
              onClick={() => setIsOpen(false)}
            >
              {"Service Request"}
            </NavLink>
          </div>
        )}
        </div>
      </Drawer>
    </>
  );
};

export default RightDrawer;
